const setCodeMirrorValue = val => {
  document.querySelector('.CodeMirror').CodeMirror.setValue(val);
};

export default setCodeMirrorValue;
